window.initFileAutoUpload = function(){

    let chooseFile = ($form) => {
        $form.on('submit', function(evt) {
            evt.preventDefault();
            $form.find('input[type="file"]').trigger('click');
        })
    };

    let submitFormOnFileChange = ($form) => {
        let $inputFile = $form.find('input[type="file"]');
        $inputFile.on('change', () => ajaxSubmitForm($form));
    };

    let ajaxSubmitForm = ($form) => {
        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: new FormData($form[0]),
            contentType: false,
            processData: false,
            dataType: 'json',
            statusCode: {
                200: (res) => $form.trigger('file-autoupload:ok', res),
                400: (res) => $form.trigger('file-autoupload:error', res),
            }
        });
    };

    let $forms = $('form[data-component="file-autoupload"]');

    $forms.each((key, form) => {
        let $form = $(form);
        chooseFile($form);
        submitFormOnFileChange($form);
    });

};

if(typeof window.initFileAutoUpload === 'function') window.initFileAutoUpload();

